import React from "react";

export default function WhiteCover({ children, className, style }) {
  return (
    <div className={"white-cover " + className} style={style}>
      {children}
    </div>
  );
}
